import React, { useEffect } from "react";
import * as microsoftTeams from "@microsoft/teams-js";

const ConfigurePage = () => {
  useEffect(() => {
    microsoftTeams.app.initialize().then(() => {
      microsoftTeams.pages.config.registerOnSaveHandler((saveEvent) => {
        microsoftTeams.pages.config.setConfig({
          entityID: "meeting-tab",
          contentUrl: `${window.location.origin}`,
          websiteUrl: `${window.location.origin}`,
          suggestedTabName: "SnapFeedback",
        });
        saveEvent.notifySuccess();
      });
    });
  }, []);

  const enableSave = () => {
    microsoftTeams.pages.config.setValidityState(true);
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>Set up SnapFeedback for this meeting</h2>
      <p>
        This tab will allow participants to access SnapFeedback during the
        meeting. Click <strong>Save</strong> to continue.
      </p>

      <p>
        Need help? <a href="mailto:contact@snapfeedback.co">Contact Support</a>
      </p>

      <button onClick={enableSave}>Enable Save</button>
    </div>
  );
};

export default ConfigurePage;
